import { reducer } from "./reducer"
export const InventoryConfigurationReducer = reducer

export * from "./types"



// WEBPACK FOOTER //
// ./src/state/inventory/configuration/reducers/index.ts